import { PartnersCodes } from 'constants/partners';

export const PARTNERS_LOGO_CDN_BASE = 'https://cdn.checkmate.tech/checkmate-files/assets/partners/';

const partnerLogo = filename => `${PARTNERS_LOGO_CDN_BASE}${filename}`;

export const PartnersConfig = [
  {
    name: 'account_api',
    logo: 'https://cdn.checkmate.tech/checkmate-files/assets/checkmate_logo.svg',
    title: 'Account API',
    description: 'Learn more about our Account API integration',
  },
  {
    name: 'avature',
    logo: partnerLogo('avature.svg'),
    title: 'Avature',
    description: 'Learn more about our Avature integration',
    infoOnly: true,
  },
  {
    name: 'bullhorn',
    logo: partnerLogo('bullhorn.svg'),
    title: 'Bullhorn',
    description: 'Learn more about our Bullhorn integration',
    infoOnly: true,
  },
  {
    name: 'expr3ss',
    logo: partnerLogo('expr3ss.svg'),
    title: 'Expr3ss!',
    description: 'Learn more about our Expr3ss! integration',
    infoOnly: true,
  },
  {
    name: 'livehire',
    logo: partnerLogo('humanforce.svg'),
    title: 'Humanforce',
    description: 'Learn more about our Humanforce integration',
  },
  {
    name: 'imis',
    logo: partnerLogo('imis.svg'),
    title: 'iMIS',
    description: 'Learn more about our iMIS integration',
    infoOnly: true,
  },
  {
    name: 'jazzhr',
    logo: partnerLogo('jazzhr.svg'),
    title: 'JazzHR',
    description: 'Learn more about our JazzHR integration',
  },
  {
    name: 'job_adder',
    logo: partnerLogo('jobadder.svg'),
    title: 'JobAdder',
    description: 'Learn more about our JobAdder integration',
  },
  {
    name: 'lever',
    logo: partnerLogo('lever.svg'),
    title: 'Lever',
    description: 'Learn more about our Lever integration',
  },
  {
    name: 'pageup',
    logo: partnerLogo('pageup.svg'),
    title: 'PageUp',
    description: 'Learn more about our PageUp integration',
  },
  {
    name: 'ready_employ',
    logo: partnerLogo('ready_employ.svg'),
    title: 'Ready Employ',
    description: 'Learn more about our Ready Employ integration',
    infoOnly: true,
  },
  {
    name: 'sap_successfactors',
    logo: partnerLogo('sap_successfactors.svg'),
    title: 'SAP SuccessFactors',
    description: 'Learn more about our SAP SuccessFactors integration',
    infoOnly: true,
  },
  {
    name: 'smartrecruiters',
    logo: partnerLogo('smartrecruiters.svg'),
    title: 'SmartRecruiters',
    description: 'Learn more about our SmartRecruiters integration',
    infoOnly: true,
  },
  {
    name: 'snaphire',
    partnerCode: PartnersCodes.TAS,
    logo: partnerLogo('snaphire.svg'),
    title: 'SnapHire',
    description: 'Learn more about our SnapHire integration',
  },
  {
    name: 'springboard',
    logo: partnerLogo('springboard.svg'),
    title: 'Springboard',
    description: 'Learn more about our Springboard integration',
    infoOnly: true,
  },
  {
    name: 'teamtailor',
    logo: partnerLogo('teamtailor.svg'),
    title: 'Teamtailor',
    description: 'Learn more about our Teamtailor integration',
  },
  {
    name: 'ukg',
    logo: partnerLogo('ukg.svg'),
    title: 'UKG Ready',
    description: 'Learn more about our UKG Ready integration',
    infoOnly: true,
  },
  {
    name: 'workable',
    logo: partnerLogo('workable.svg'),
    title: 'Workable',
    description: 'Learn more about our Workable integration',
    infoOnly: true,
  },
  {
    name: 'workato',
    logo: partnerLogo('workato.svg'),
    title: 'Workato',
    description: 'Learn more about our Workato integration',
    infoOnly: true,
    contactMessageTemplate: 'Need help setting up a Workato workflow? Contact us at {email}.',
  },
  {
    name: 'workday',
    logo: partnerLogo('workday.svg'),
    title: 'Workday',
    description: 'Learn more about our Workday integration',
    infoOnly: true,
  },
];
